import { settingsStringParsing } from "@orbital/games-frontend-library"
const settings = [
  { name: "stake", minStake: "", maxStake: "100000000000.00" },
  { name: "numberOfBets" },
  { name: "music" },
  { name: "sound" },
  { name: "volume" },
]
export const helperReceiveSettings = (
  str: string,
  setstake: any,
  setlastStake: any,
  setautoConfigs: any,
  setaudio: any,
) => {
  // const { stake, autoConfigs, audio } = stringToObjSettings(str);
  // setstake(stake);
  // setautoConfigs(autoConfigs);
  // setaudio(audio);
  const [stake, numberOfBets, music, sound, volume1, ,] = settingsStringParsing(
    str,
    settings,
  )
  setstake(stake)
  setlastStake(stake)
  setautoConfigs({ numberOfBets })
  setaudio({ music, sound, volume: volume1 })
}
